import { render } from "./FileRenderer.vue?vue&type=template&id=02d10ad5"
import script from "./FileRenderer.vue?vue&type=script&lang=js"
export * from "./FileRenderer.vue?vue&type=script&lang=js"

import "./FileRenderer.vue?vue&type=style&index=0&id=02d10ad5&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__